import { STATE_CODES } from '@pfsc/core/models/state';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { currencyUtils } from '../utils/currency';
import { PackageIncludedProduct } from './included-product';

export const PRINTED_COPY_PACKAGE_ID = 3003;
export const RETEST_PACKAGE_ID = 3012;
export const RESCHEDULE_PACKAGE_ID = 3011;

export const OREGON_PACKAGE_ID = 3026;

export const CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID = 1420;
export const ILLINOIS_BASSET_PACKAGE_ID = 1430;
export const FLORIDA_ON_PREMISES_PACKAGE_ID = 3036;
export const FLORIDA_OFF_PREMISES_PACKAGE_ID = 3037;
export const ALLERGEN_PACKAGE_ID = 3035;

export const FOOD_HANDLER_PACKAGE_ID = {
  CALIFORNIA: 1240,
  FLORIDA: 1270,
  ARIZONA: 1400,
  TEXAS: 1280,
  NEW_MEXICO: 2012,
  ILLINOIS: 1370,
  UTAH: 1390,
  KANSAS: 1330,
  SAN_DIEGO: 1380,
};

export const COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID = {
  CLASSROOM_BASIC: 1050,
  CLASSROOM_STANDARD: 1000,
  CLASSROOM_PREMIUM: 1001,
};

export const COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID = {
  ONLINE_BASIC: 2016,
  ONLINE_STANDARD: 1210,
  ONLINE_PREMIUM: 2014,
};

export const IL_FOOD_MANAGER_CLASSROOM_PACKAGE_ID = {
  ILLINOIS: 1003,
};

export const IL_FOOD_MANAGER_ONLINE_PACKAGE_ID = {
  ILLINOIS: 1410,
};

export const LAMINATED_CARD_PACKAGE_ID = {
  CALIFORNIA: 3002,
  ARIZONA: 3009,
  FLORIDA: 3004,
  TEXAS: 3005,
  NEW_MEXICO: 3007,
  ILLINOIS: 3006,
  SAN_DIEGO: 3008,
};

export const LAMINATED_CERTIFICATE_PACKAGE_ID = {
  SAN_DIEGO: 3029,
};

export const AB_1825_PACKAGE_ID = {
  SUPERVISOR: 1220,
  EMPLOYEE: 1320,
};

export const PACKAGE_CATEGORY_RECORD = {
  ServSafeCertification: 1000,
  AlcoholServiceClass: 1100,
  PrometricCertification: 1200,
  PFSElearning: 1300,
  AB1825SupervisorClass: 2000,
  SexualHarassmentPreventionEmployeeClass: 2010,
  ApexElearning: 2100,
  AllergenTraining: 2200,
  FoodHandlerClass: 3000,
};

export const FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CARD_PACKAGE_ID = {
  [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA]: LAMINATED_CARD_PACKAGE_ID.CALIFORNIA,
  [FOOD_HANDLER_PACKAGE_ID.FLORIDA]: LAMINATED_CARD_PACKAGE_ID.FLORIDA,
  [FOOD_HANDLER_PACKAGE_ID.ARIZONA]: LAMINATED_CARD_PACKAGE_ID.ARIZONA,
  [FOOD_HANDLER_PACKAGE_ID.TEXAS]: LAMINATED_CARD_PACKAGE_ID.TEXAS,
  [FOOD_HANDLER_PACKAGE_ID.NEW_MEXICO]: LAMINATED_CARD_PACKAGE_ID.NEW_MEXICO,
  [FOOD_HANDLER_PACKAGE_ID.ILLINOIS]: LAMINATED_CARD_PACKAGE_ID.ILLINOIS,
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: LAMINATED_CARD_PACKAGE_ID.SAN_DIEGO,
};

export const FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CERT_PACKAGE_ID = {
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: LAMINATED_CERTIFICATE_PACKAGE_ID.SAN_DIEGO,
};

export const FOOD_HANDLER_PACKAGE_ID_TO_ALCOHOL_PACKAGE_ID = {
  [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA]: CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID,
  [FOOD_HANDLER_PACKAGE_ID.ILLINOIS]: ILLINOIS_BASSET_PACKAGE_ID,
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID,
};

export const ALCOHOL_PACKAGE_ID_TO_FOOD_HANDLER_PACKAGE_ID = {
  [CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID]: [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA],
  [ILLINOIS_BASSET_PACKAGE_ID]: [FOOD_HANDLER_PACKAGE_ID.ILLINOIS],
};

/**
 * Food Handler Card packages that hide an alcohol line's Food Handler Card add-on when already in the cart,
 */
export const ALCOHOL_PACKAGE_ID_TO_COVERING_FOOD_HANDLER_PACKAGE_ID = {
  [CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID]: [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA, FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO],
  [ILLINOIS_BASSET_PACKAGE_ID]: [FOOD_HANDLER_PACKAGE_ID.ILLINOIS],
};

export const ALCOHOL_PACKAGE_ID_TO_FOOD_MANAGER_PACKAGE_ID = {
  [CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID]: [
    COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID.CLASSROOM_BASIC,
    COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID.CLASSROOM_STANDARD,
    COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID.CLASSROOM_PREMIUM,
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_BASIC,
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_STANDARD,
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_PREMIUM,
  ],
  [ILLINOIS_BASSET_PACKAGE_ID]: [
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_BASIC,
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_STANDARD,
    COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID.ONLINE_PREMIUM,
    IL_FOOD_MANAGER_CLASSROOM_PACKAGE_ID.ILLINOIS,
    IL_FOOD_MANAGER_ONLINE_PACKAGE_ID.ILLINOIS,
  ],
};

export const ALCOHOL_PACKAGE_ID = {
  CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID,
  ILLINOIS_BASSET_PACKAGE_ID,
  FLORIDA_ON_PREMISES_PACKAGE_ID,
  FLORIDA_OFF_PREMISES_PACKAGE_ID,
};

export const ALCOHOL_PACKAGE_ID_TO_CTA = {
  [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA]: globalTranslate('purchasePackages.rbsCta'),
  [FOOD_HANDLER_PACKAGE_ID.ILLINOIS]: globalTranslate('purchasePackages.bassetCta'),
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: globalTranslate('purchasePackages.rbsCta'),
};

export const FOOD_HANDLER_PACKAGE_IDS_WITH_NO_SERSAVE_IMAGE = [
  CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID,
  ILLINOIS_BASSET_PACKAGE_ID,
  FLORIDA_ON_PREMISES_PACKAGE_ID,
  FLORIDA_OFF_PREMISES_PACKAGE_ID,
  AB_1825_PACKAGE_ID.SUPERVISOR,
  AB_1825_PACKAGE_ID.EMPLOYEE,
  FOOD_HANDLER_PACKAGE_ID.UTAH,
  FOOD_HANDLER_PACKAGE_ID.KANSAS,
  FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO,
  ALLERGEN_PACKAGE_ID,
];

export const FH_PACKAGE_ID_TO_CTA = {
  [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA]: globalTranslate('purchasePackages.caFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.ILLINOIS]: globalTranslate('purchasePackages.ilFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: globalTranslate('purchasePackages.sdFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.FLORIDA]: globalTranslate('purchasePackages.flFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.ARIZONA]: globalTranslate('purchasePackages.azFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.TEXAS]: globalTranslate('purchasePackages.txFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.NEW_MEXICO]: globalTranslate('purchasePackages.nmFhCta'),
  [FOOD_HANDLER_PACKAGE_ID.UTAH]: globalTranslate('purchasePackages.utFhCta'),
};

/** Maps a state code to the state's Food Handler course package ID (states offered as a Food Manager add-on). */
export const STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID = {
  [STATE_CODES.CALIFORNIA]: FOOD_HANDLER_PACKAGE_ID.CALIFORNIA,
  [STATE_CODES.FLORIDA]: FOOD_HANDLER_PACKAGE_ID.FLORIDA,
  [STATE_CODES.ARIZONA]: FOOD_HANDLER_PACKAGE_ID.ARIZONA,
  [STATE_CODES.TEXAS]: FOOD_HANDLER_PACKAGE_ID.TEXAS,
  [STATE_CODES.NEW_MEXICO]: FOOD_HANDLER_PACKAGE_ID.NEW_MEXICO,
  [STATE_CODES.ILLINOIS]: FOOD_HANDLER_PACKAGE_ID.ILLINOIS,
  [STATE_CODES.UTAH]: FOOD_HANDLER_PACKAGE_ID.UTAH,
};

export const FOOD_HANDLER_PACKAGE_ID_TO_CARD_IMAGE_URL = {
  [FOOD_HANDLER_PACKAGE_ID.CALIFORNIA]: '/assets/images/cards/cafoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.FLORIDA]: '/assets/images/cards/flfoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.ARIZONA]: '/assets/images/cards/azfoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.TEXAS]: '/assets/images/cards/txfoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.NEW_MEXICO]: '/assets/images/cards/nmfoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.ILLINOIS]: '/assets/images/cards/ilfoodhandlercard.png',
  [FOOD_HANDLER_PACKAGE_ID.UTAH]: '/assets/images/components/flyer-foodhandler-utah.png',
};

export const LAMINATED_CARD_PACKAGE_ID_TO_LAMINATED_CARD_IMAGE_URL = {
  [LAMINATED_CARD_PACKAGE_ID.CALIFORNIA]: '/assets/images/cards/cafoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.FLORIDA]: '/assets/images/cards/flfoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.ARIZONA]: '/assets/images/cards/azfoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.TEXAS]: '/assets/images/cards/txfoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.NEW_MEXICO]: '/assets/images/cards/nmfoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.ILLINOIS]: '/assets/images/cards/ilfoodhandlercard.png',
  [LAMINATED_CARD_PACKAGE_ID.SAN_DIEGO]: '/assets/images/cards/sdfoodhandlercard.png',
};

export const LAMINATED_CERT_PACKAGE_ID_TO_LAMINATED_CERT_IMAGE_URL = {
  [LAMINATED_CERTIFICATE_PACKAGE_ID.SAN_DIEGO]: '/assets/images/cards/SD_CERTIFICATE.png',
};

export const ALCOHOL_PACKAGE_ID_TO_ALCOHOL_IMAGE_URL = {
  [CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID]: '/assets/images/components/rbs-purchase.png',
  [ILLINOIS_BASSET_PACKAGE_ID]: '/assets/images/components/basset-purchase.png',
  [FLORIDA_ON_PREMISES_PACKAGE_ID]: '/assets/images/cards/alcohol/fl-alcohol-on-premises-card.png',
  [FLORIDA_OFF_PREMISES_PACKAGE_ID]: '/assets/images/cards/alcohol/fl-alcohol-off-premises-card.png',
};

export const ALCOHOL_PACKAGE_ID_TO_ALCOHOL_CTA = {
  [CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID]: globalTranslate('purchasePackages.rbsCta'),
  [ILLINOIS_BASSET_PACKAGE_ID]: globalTranslate('purchasePackages.bassetCta'),
};

export const AB_1825_PACKAGE_ID_TO_AB_1825_IMAGE_URL = {
  [AB_1825_PACKAGE_ID.SUPERVISOR]: '/assets/images/apex/apexsupervisorcert.png',
  [AB_1825_PACKAGE_ID.EMPLOYEE]: '/assets/images/apex/apexemployeecert.png',
};

/** @type {Record<number, string>} */
export const ALLERGEN_PACKAGE_ID_TO_ALLERGEN_IMAGE_URL = {
  [ALLERGEN_PACKAGE_ID]: '/assets/images/components/allergen-cert.png',
};

/**
 * Food Handler courses sold for a local jurisdiction instead of a whole state, mapped to the state they sit in
 * (Kansas City → MO, San Diego County → CA).
 */
export const LOCAL_FOOD_HANDLER_PACKAGE_ID_TO_STATE_CODE = {
  [FOOD_HANDLER_PACKAGE_ID.KANSAS]: STATE_CODES.MISSOURI,
  [FOOD_HANDLER_PACKAGE_ID.SAN_DIEGO]: STATE_CODES.CALIFORNIA,
};

/**
 * Resolves a Food Handler package id to its state code: the inverse of STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID
 * plus the local-jurisdiction courses above. Used to compare a Food Handler line's state against the backend
 * Allergen Training state list;
 * @type {Record<number, string>}
 */
export const FOOD_HANDLER_PACKAGE_ID_TO_STATE_CODE = {
  ...Object.fromEntries(
    Object.entries(STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID).map(
      ([stateCode, packageId]) => [packageId, stateCode],
    ),
  ),
  ...LOCAL_FOOD_HANDLER_PACKAGE_ID_TO_STATE_CODE,
};

export const DEPOSIT_PACKAGE_IDS = {
  EXECUTIVE: 3031,
  CORPORATE: 3032,
  OPERATOR: 3033,
};

export const DEPOSIT_PACKAGE_LIST = [
  DEPOSIT_PACKAGE_IDS.EXECUTIVE,
  DEPOSIT_PACKAGE_IDS.CORPORATE,
  DEPOSIT_PACKAGE_IDS.OPERATOR,
];

/** Package */
export class BasePackage {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.typeId = data.typeId;
    this.type = data.type;
    this.expensesAmount = data.expensesAmount;
    this.expensesDescription = data.expensesDescription;
    this.classCategoryId = data.classCategoryId;
  }

  /**
   * Map to readable
   * @param {BasePackage} basePackage Package.
   * @returns {string}
   */
  static toReadable(basePackage) {
    return basePackage.name;
  }

  /**
   * Map to detail readable
   * @param {BasePackage} basePackage Package.
   * @returns {string}
   */
  static toDetailReadable(basePackage) {
    return [basePackage.name, basePackage.description]
      .filter(Boolean)
      .join(' - ');
  }

  /**
   * Map to detail readable
   * @param {BasePackage} basePackage Package.
   * @returns {string}
   */
  static toDetailReadableWithPrice(basePackage) {
    const detail = BasePackage.toDetailReadable(basePackage);
    return `${detail} (${currencyUtils.toUSCurrency(basePackage.price)})`;
  }

  /**
   * Get food handler card url.
   * @param {Package} packageItem Package.
   * @returns {{imageUrl: string, laminatedCardPackageId: number, labelText: string} | null}
   */
  static getFoodHandlerCardInfoUrl(packageItem) {
    const laminatedCardPackageId = FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CARD_PACKAGE_ID[packageItem.id];
    if (laminatedCardPackageId == null) {
      return null;
    }
    const imageUrl = LAMINATED_CARD_PACKAGE_ID_TO_LAMINATED_CARD_IMAGE_URL[
      laminatedCardPackageId
    ];
    const labelText = FH_PACKAGE_ID_TO_CTA[
      packageItem.id
    ];

    return {
      imageUrl,
      laminatedCardPackageId,
      labelText,
    };
  }

  /**
   * Get food handler cert url.
   * @param {Package} packageItem Package.
   * @returns {{imageUrl: string, laminatedCertPackageId: number} | null}
   */
  static getFoodHandlerCertInfoUrl(packageItem) {
    const laminatedCertPackageId = FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CERT_PACKAGE_ID[packageItem.id];
    const imageUrl = LAMINATED_CERT_PACKAGE_ID_TO_LAMINATED_CERT_IMAGE_URL[
      laminatedCertPackageId
    ];

    return {
      imageUrl,
      laminatedCertPackageId,
    };
  }

  /**
   * Get alcohol package image url.
   * @param {Package} packageItem Package.
   * @returns {{imageUrl: string, alcoholPackageId: number, labelText: string} | null}
   */
  static getAlcoholPackageImgUrl(packageItem) {
    const alcoholPackageId = this.isAlcoholPackage(packageItem.id)? packageItem.id : FOOD_HANDLER_PACKAGE_ID_TO_ALCOHOL_PACKAGE_ID[packageItem.id];
    if (alcoholPackageId == null) {
      return null;
    }
    const imageUrl = ALCOHOL_PACKAGE_ID_TO_ALCOHOL_IMAGE_URL[
      alcoholPackageId
    ];
    const labelText = ALCOHOL_PACKAGE_ID_TO_CTA[
      packageItem.id
    ];

    return {
      imageUrl,
      alcoholPackageId,
      labelText,
    };
  }

  /**
   * Get AB 1825 package image url.
   * @param {Package} packageItem Package.
   * @returns {{imageUrl: string, ab1825PackageId: number} | null}
   */
  static getAb1825PackageImgUrl(packageItem) {
    if (!AB_1825_PACKAGE_ID_TO_AB_1825_IMAGE_URL[packageItem.id]) {
      return null;
    }

    return {
      imageUrl: AB_1825_PACKAGE_ID_TO_AB_1825_IMAGE_URL[packageItem.id],
      ab1825PackageId: packageItem.id,
    };
  }

  /**
   * Get Allergen package image url.
   * @param {Package} packageItem Package.
   * @returns {{imageUrl: string, allergenPackageId: number} | null}
   */
  static getAllergenPackageImgUrl(packageItem) {
    if (!ALLERGEN_PACKAGE_ID_TO_ALLERGEN_IMAGE_URL[packageItem.id]) {
      return null;
    }

    return {
      imageUrl: ALLERGEN_PACKAGE_ID_TO_ALLERGEN_IMAGE_URL[packageItem.id],
      allergenPackageId: packageItem.id,
    };
  }

  /**
   * Get laminated card ID by food handler ID.
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {number}
   */
  static getLaminatedCardPackageIdByFoodHandlerPackageId(foodHandlerPackageId) {
    return FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CARD_PACKAGE_ID[
      foodHandlerPackageId
    ];
  }

  /**
   * Get laminated cert ID by food handler ID.
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {number}
   */
  static getLaminatedCertPackageIdByFoodHandlerPackageId(foodHandlerPackageId) {
    return FOOD_HANDLER_PACKAGE_ID_TO_LAMINATED_CERT_PACKAGE_ID[
      foodHandlerPackageId
    ];
  }

  /**
   * Get Alcohol RBS / IL BASSET ID by food handler ID.
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {number}
   */
  static getAlcoholIdByFoodHandlerPackageId(foodHandlerPackageId) {
    return FOOD_HANDLER_PACKAGE_ID_TO_ALCOHOL_PACKAGE_ID[
      foodHandlerPackageId
    ];
  }

  /**
   * Get Alcohol RBS ID by food manager package ID.
   * @param {number} foodManagerPackageId Food manager package ID.
   * @param {string } stateCode State
   * @returns {number | null}
   */
  static getAlcoholIdByFoodManagerPackageId(foodManagerPackageId, stateCode) {
    const commonFoodManagerPackageIds = [
      ...Object.values(COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID),
      ...Object.values(COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID),
    ];
    const ILFoodManagerPackageIds = [
      ...Object.values(IL_FOOD_MANAGER_CLASSROOM_PACKAGE_ID),
      ...Object.values(IL_FOOD_MANAGER_ONLINE_PACKAGE_ID),
    ];

    if (foodManagerPackageId && stateCode && commonFoodManagerPackageIds.includes(foodManagerPackageId)) {
      switch (stateCode) {
        case STATE_CODES.CALIFORNIA:
          // Only return CA RBS if the package state is CA (if state is available) or generally return it
          return CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID;
        case STATE_CODES.ILLINOIS:
          return ILLINOIS_BASSET_PACKAGE_ID;
        default:
          return null;
      }
    } else if (ILFoodManagerPackageIds.includes(foodManagerPackageId)) {
      return ILLINOIS_BASSET_PACKAGE_ID;
    }

    return null;
  }

  /**
   * Get alcohol package image url for food manager add-on.
   * @param {number} packageItemId Package.
   * @param {string} stateCode Package.
   * @returns {{imageUrl: string, alcoholPackageId: number, labelText: string} | null}
   */
  static getAlcoholPackageImgUrlForFoodManager(packageItemId, stateCode) {
    const alcoholPackageId = this.getAlcoholIdByFoodManagerPackageId(packageItemId, stateCode);
    if (alcoholPackageId == null) {
      return null;
    }
    const imageUrl = ALCOHOL_PACKAGE_ID_TO_ALCOHOL_IMAGE_URL[
      alcoholPackageId
    ];
    const labelText = ALCOHOL_PACKAGE_ID_TO_ALCOHOL_CTA?.[alcoholPackageId] || '';

    return {
      imageUrl,
      alcoholPackageId,
      labelText,
    };
  }

  /**
   * PFS-298: whether a Premium package shows the free Food Handler Card for a state.
   * The offer must be on and the state must have a Food Handler package (same list the backend uses).
   * @param {{has_free_food_handler_card?: boolean} | null | undefined} premiumPackageDto Premium package from the API.
   * @param {string | null | undefined} stateCode State code of the page.
   * @returns {boolean}
   */
  static hasFreeFoodHandlerCardForState(premiumPackageDto, stateCode) {
    if (!stateCode || !STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID[stateCode]) {
      return false;
    }

    return Boolean(premiumPackageDto?.has_free_food_handler_card);
  }

  /**
   * Get the state's Food Handler course package ID offered as a Food Manager add-on.
   * @param {number} foodManagerPackageId Food manager package ID.
   * @param {string} stateCode State
   * @returns {number | null}
   */
  static getFoodHandlerIdByFoodManagerPackageId(foodManagerPackageId, stateCode) {
    const commonFoodManagerPackageIds = [
      ...Object.values(COMMON_FOOD_MANAGER_CLASSROOM_PACKAGE_ID),
      ...Object.values(COMMON_FOOD_MANAGER_ONLINE_PACKAGE_ID),
    ];
    const ILFoodManagerPackageIds = [
      ...Object.values(IL_FOOD_MANAGER_CLASSROOM_PACKAGE_ID),
      ...Object.values(IL_FOOD_MANAGER_ONLINE_PACKAGE_ID),
    ];

    if (foodManagerPackageId && stateCode && commonFoodManagerPackageIds.includes(foodManagerPackageId)) {
      return STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID[stateCode] ?? null;
    } else if (ILFoodManagerPackageIds.includes(foodManagerPackageId)) {
      return FOOD_HANDLER_PACKAGE_ID.ILLINOIS;
    }

    return null;
  }

  /**
   * Get food handler card image url for food manager add-on.
   * @param {number} packageItemId Food manager package ID.
   * @param {string} stateCode State
   * @returns {{imageUrl: string, foodHandlerPackageId: number, labelText: string} | null}
   */
  static getFoodHandlerCardImgUrlForFoodManager(packageItemId, stateCode) {
    const foodHandlerPackageId = this.getFoodHandlerIdByFoodManagerPackageId(packageItemId, stateCode);
    if (foodHandlerPackageId == null) {
      return null;
    }
    const imageUrl = FOOD_HANDLER_PACKAGE_ID_TO_CARD_IMAGE_URL[foodHandlerPackageId];
    const labelText = FH_PACKAGE_ID_TO_CTA?.[foodHandlerPackageId] || '';

    return {
      imageUrl,
      foodHandlerPackageId,
      labelText,
    };
  }

  /**
   * Get the state's Food Handler course package ID offered as a Food Allergen Awareness Training add-on.
   * Note: STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID is shared with the Food Manager add-on mapping,
   * so adding a state there changes both add-ons.
   * @param {number} allergenPackageId Allergen training package ID.
   * @param {string} stateCode State
   * @returns {number | null}
   */
  static getFoodHandlerIdByAllergenPackageId(allergenPackageId, stateCode) {
    if (allergenPackageId === ALLERGEN_PACKAGE_ID && stateCode) {
      return STATE_CODE_TO_FOOD_HANDLER_PACKAGE_ID[stateCode] ?? null;
    }

    return null;
  }

  /**
   * Get food handler card image url for allergen training add-on.
   * @param {number} packageItemId Allergen training package ID.
   * @param {string} stateCode State
   * @returns {{imageUrl: string, foodHandlerPackageId: number, labelText: string} | null}
   */
  static getFoodHandlerCardImgUrlForAllergen(packageItemId, stateCode) {
    const foodHandlerPackageId = this.getFoodHandlerIdByAllergenPackageId(packageItemId, stateCode);
    if (foodHandlerPackageId == null) {
      return null;
    }
    const imageUrl = FOOD_HANDLER_PACKAGE_ID_TO_CARD_IMAGE_URL[foodHandlerPackageId];
    const labelText = FH_PACKAGE_ID_TO_CTA?.[foodHandlerPackageId] || '';

    return {
      imageUrl,
      foodHandlerPackageId,
      labelText,
    };
  }

  /**
   * Get the Food Allergen Awareness Training package ID offered as an add-on under a Food Handler line.
   * Returns ALLERGEN_PACKAGE_ID (`3035`) for any Food Handler course that resolves to a state code — the
   * statewide courses plus the local-jurisdiction ones (Kansas City, San Diego County) — null otherwise.
   * Whether that state actually offers the Allergen training is checked separately against the backend
   * state list; see the Allergen add-on guard in orderBrief.vue.
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {number | null}
   */
  static getAllergenIdByFoodHandlerPackageId(foodHandlerPackageId) {
    return FOOD_HANDLER_PACKAGE_ID_TO_STATE_CODE[foodHandlerPackageId] != null
      ? ALLERGEN_PACKAGE_ID
      : null;
  }

  /**
   * Resolve a Food Handler package id to its state code.
   * Used to check the Food Handler line's state against the backend Allergen Training state list.
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {string | null}
   */
  static getStateCodeByFoodHandlerPackageId(foodHandlerPackageId) {
    return FOOD_HANDLER_PACKAGE_ID_TO_STATE_CODE[foodHandlerPackageId] ?? null;
  }

  /**
   * Get allergen package image url + CTA for the Food Handler → Allergen add-on.
   * Mirrors getFoodHandlerCardImgUrlForFoodManager. The label is state-agnostic (single Allergen package).
   * @param {number} foodHandlerPackageId Food handler package ID.
   * @returns {{imageUrl: string, allergenPackageId: number, labelText: string} | null}
   */
  static getAllergenPackageImgUrlForFoodHandler(foodHandlerPackageId) {
    const allergenPackageId = this.getAllergenIdByFoodHandlerPackageId(foodHandlerPackageId);
    if (allergenPackageId == null) {
      return null;
    }

    const imageUrl = ALLERGEN_PACKAGE_ID_TO_ALLERGEN_IMAGE_URL[allergenPackageId];
    const labelText = globalTranslate('purchasePackages.allergenCta');

    return {
      imageUrl,
      allergenPackageId,
      labelText,
    };
  }

  /**
   * Get food handler package ID from alcohol training.
   * @param {number} alcoholPackageId alcohol training package ID.
   * @returns {Array<number>}
   */
  static getFoodHandlerPackageIdByAlcoholId(alcoholPackageId) {
    return ALCOHOL_PACKAGE_ID_TO_FOOD_HANDLER_PACKAGE_ID[
      alcoholPackageId
    ] ?? [];
  }

  /**
   * Get the food handler package IDs that satisfy an alcohol training's food handler card add-on when already
   * in the cart, including cards the alcohol line no longer offers itself (e.g. the San Diego card under CA RBS).
   * @param {number} alcoholPackageId alcohol training package ID.
   * @returns {Array<number>}
   */
  static getCoveringFoodHandlerPackageIdByAlcoholId(alcoholPackageId) {
    return ALCOHOL_PACKAGE_ID_TO_COVERING_FOOD_HANDLER_PACKAGE_ID[
      alcoholPackageId
    ] || [];
  }

  /**
   * Get food manager package ID from alcohol training.
   * @param {number} alcoholPackageId alcohol training package ID.
   * @returns {Array<number>}
   */
  static getFoodManagerPackageIdByAlcoholId(alcoholPackageId) {
    return ALCOHOL_PACKAGE_ID_TO_FOOD_MANAGER_PACKAGE_ID[
      alcoholPackageId
    ] || [];
  }

  /**
   * Whether sersave image should be display.
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isNoSersaveImage(packageId) {
    return FOOD_HANDLER_PACKAGE_IDS_WITH_NO_SERSAVE_IMAGE.includes(packageId);
  }

  /**
   * Whether additional deposit text should be display.
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isDepositPackage(packageId) {
    return DEPOSIT_PACKAGE_LIST.includes(packageId);
  }

  /**
   * Whether sersave image should be display.
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isLaminatedCardPackage(packageId) {
    return Object.values(LAMINATED_CARD_PACKAGE_ID).includes(packageId);
  }

  /**
   * Whether laminated cert should be display.
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isLaminatedCertPackage(packageId) {
    return Object.values(LAMINATED_CERTIFICATE_PACKAGE_ID).includes(packageId);
  }

  /**
   * Whether alcohol training image should be display.
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isAlcoholPackage(packageId) {
    return Object.values(ALCOHOL_PACKAGE_ID).includes(packageId);
  }

  /**
   * Whether the package is a Florida alcohol training (On-Premises / Off-Premises).
   * @param {number} packageId Package ID.
   * @returns {boolean}
   */
  static isFloridaAlcoholPackage(packageId) {
    return [FLORIDA_ON_PREMISES_PACKAGE_ID, FLORIDA_OFF_PREMISES_PACKAGE_ID].includes(packageId);
  }

  /**
   * Get readable unit price from special package.
   * @param {Package} p Package.
   * @returns {string}
   */
  static getReadableUnitPriceFromSpecialPackage(p) {
    if (p == null) {
      return '';
    }
    return currencyUtils.toUSCurrency(p.includedProducts[0].unitPrice);
  }
}

/** Package */
export class Package extends BasePackage {
  constructor(data) {
    super(data);

    /** @type {PackageIncludedProduct[]} */
    this.includedProducts = data.includedProducts;

    this.expensesAmount = data.expensesAmount;
    this.expensesDescription = data.expensesDescription;
    this.optionalProducts = data.optionalProducts;
    this.packageDiscounts = data.packageDiscounts;
    this.states = data.states;
    this.hasClassProduct = data.hasClassProduct;
    this.code = data.code;
    this.editDate = data.editDate;
    this.remainingQuantity = data.remainingQuantity;
    this.isLaminatedCard = data.isLaminatedCard;
    this.isBestValue = data.isBestValue;
    this.promotionText = data.promotionText;
    this.retailPrice = data.retailPrice;

    /** @type {boolean} PFS-298: Premium package currently includes a free Food Handler Card. */
    this.hasFreeFoodHandlerCard = data.hasFreeFoodHandlerCard ?? false;
  }
}
